// src/styles/tokens.js
export const colors = {
  bg:        '#0a0a0f',
  bgElev:    '#111118',
  bgHover:   '#16161f',
  border:    'rgba(255, 255, 255, 0.08)',
  borderHi:  'rgba(100, 255, 218, 0.25)',
  text:      '#e4e4e7',
  textDim:   '#a1a1aa',
  textMuted: '#71717a',
  accent:    '#64ffda',
  grad1:     '#a855f7',
  grad2:     '#22d3ee',
  gradText:  'linear-gradient(90deg, #a855f7, #64ffda)',
  gradFeat:  'linear-gradient(135deg, #a855f7, #22d3ee)',
};

export const fonts = {
  sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "'JetBrains Mono', 'Fira Code', Menlo, Consolas, monospace",
};

export const fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  base: '1rem',
  md: '1.125rem',
  lg: '1.5rem',
  xl: '2rem',
  '2xl': '3rem',
  hero: 'clamp(2.5rem, 8vw, 4.5rem)',
};

export const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  black: 800,
};

export const space = {
  0.5: '0.25rem',
  1:   '0.5rem',
  2:   '0.75rem',
  3:   '1rem',
  4:   '1.5rem',
  5:   '2rem',
  6:   '3rem',
  8:   '4rem',
  10:  '6rem',
  12:  '8rem',
};

export const radii = {
  sm:   '4px',
  md:   '8px',
  lg:   '12px',
  xl:   '16px',
  '2xl':'24px',
  full: '9999px',
};

export const shadows = {
  card:       '0 1px 2px rgba(0, 0, 0, 0.4)',
  cardHover:  '0 8px 24px rgba(0, 0, 0, 0.5)',
  glowAccent: '0 0 24px rgba(100, 255, 218, 0.15)',
  glowPurple: '0 0 32px rgba(168, 85, 247, 0.2)',
};

export const ease = {
  soft:    'cubic-bezier(0.22, 1, 0.36, 1)',
  springy: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  linear:  'linear',
};

export const duration = {
  fast:  '120ms',
  base:  '300ms',
  slow:  '600ms',
  xslow: '800ms',
};

export const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};

export const mq = {
  sm: `@media (min-width: ${breakpoints.sm})`,
  md: `@media (min-width: ${breakpoints.md})`,
  lg: `@media (min-width: ${breakpoints.lg})`,
  xl: `@media (min-width: ${breakpoints.xl})`,
};
